import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'app/components/utils/utils.service';

@Component({
  selector: 'app-stand-display',
  templateUrl: './stand-display.component.html',
  styleUrls: ['./stand-display.component.css']
})
export class StandDisplayComponent implements OnInit {

    @Input() standData: any;

    standLocation: any;

    constructor(private utilsService: UtilsService){}

    ngOnInit() {
      if(this.standData && this.standData.length > 0) {
        this.standLocation = this.utilsService.standConvertor(this.standData);
      } else  {
        this.standLocation = { successful: false, partial: false };
      }
    }

    pavilionTranslationFinder(pavilionCode:string, fairground:string):string {
        return this.utilsService.pavilionTranslationFinder(pavilionCode, fairground);
    }

}
